<template>
    <div id="coupon">
        <div class="coupon-info">
            <h3 :class="{'coupon-title':true,invalid:isInvalid}">{{coupon.couponName}}</h3>
            <p :class="{'coupon-date':true,invalid:isInvalid}">有效期至{{coupon.endDate}}</p>
        </div>
        <div :class="{'coupon-worth':true,invalid:isInvalid}">
            ￥<span :class="{'value':true,invalid:isInvalid}">{{coupon.price}}</span>
        </div>
    </div>
</template>

<script>
export default {
  name: "Coupon",
  data() {
    return {};
  },
  props: {
    coupon: {
      type: Object,
      required: true
    },
    isInvalid: {
      type: Boolean
    }
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.invalid {
  color: #999 !important;
}
#coupon {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.3rem 0.5rem;
  margin: 0.25rem;
  background-color: #fff;
  border-radius: 10px;
  padding-bottom: 1.2rem;
  position: relative;
  &::before {
    content: "";
    display: block;
    height: 15px;
    width: 15px;
    background-color: #f5f5f5;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%);
  }
  &::after {
    content: "";
    display: block;
    height: 15px;
    width: 15px;
    background-color: #f5f5f5;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(50%, -50%);
  }
  .coupon-info {
    > .coupon-title {
      color: #000;
      font-size: 0.45rem;
      font-weight: 500;
    }
    > .coupon-date {
      color: #666;
      font-size: 0.35rem;
    }
  }
  .coupon-worth {
    color: red;
    font-size: 0.525rem;
    font-weight: 500;
    > .value {
      font-size: 0.8rem;
    }
  }
}
</style>
